import {defineStore} from 'pinia'

import {ref} from "vue";

const {DateTime} = require('luxon');

export const useFormaterStore = defineStore(
    'formatterStore',
    () => {

        const bgColorYellow = ref("#ffffe6");
        const bgColorRed = ref("#ffebe6");
        const bgColorOrange = ref("#ffebcc");
        const bgColorAqua = ref("#e6ffff");
        const bgColorGreen = ref("#ecffe6");


        function priceFormat(moneyValue) {
            return new Intl.NumberFormat('id-ID', {
                style: 'currency',
                currency: 'IDR',
                minimumFractionDigits: 0,
                maximumFractionDigits: 2
            }).format(moneyValue);
        }

        function norekStringToReadableMonth(norekValue) {
            const parsedDate = DateTime.fromFormat(norekValue, "yyyyLL", {locale: "id"});
            return parsedDate.setLocale('id').toFormat('LLL yyyy');
        }

        function thousandSeparator(value) {
            const options = {
                style: "decimal",
                useGrouping: true,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            };

            if (typeof value === "string") {
                value = Number(value);
            }

            return value.toLocaleString("id-ID", options);
        }


        function dateYyyyMmDd(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
         
            return `${year}-${month}-${day}`;
        }

        /*
        In Setup Stores:
            ref()s become state properties
            computed(()=> $bla_bla_bla; )s become getters
            function()s become actions
        */

        return {
            priceFormat,
            norekStringToReadableMonth,
            thousandSeparator,
            bgColorYellow,
            bgColorRed,
            bgColorOrange,
            bgColorAqua,
            bgColorGreen,
            dateYyyyMmDd
        };
    });